module.exports = __webpack_public_path__ + "img/bg_circle.a718f64.webp";